import { React, useEffect, useState, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { attendanceApi, timesheetApi, Util } from "../../services";
import { TabPanel, TabView } from "primereact/tabview";
import { Dialog } from "primereact/dialog";
import RejectAttendancePopup from "./rejectAttendanceDialog";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";

const UserAttendanceDetails = ({ userData, selectedIndex, attendanceRefresh }) => {
  const [rejectRowData, setRejectRowData] = useState([]);
  const [rejectDialog, setRejectDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedTab, setSelectedTab] = useState(selectedIndex);
  const [usersBySuperior, setUsersBySuperior] = useState([]);
  const [empAttendanceList, setEmpAttendanceList] = useState([]);
  const [empPendingAttendanceList, setEmpPendingAttendanceList] = useState([]);
  const dt = useRef(null);
  const { search } = useLocation();
  const urlActions = new URLSearchParams(search).get("action");

  useEffect(() => {
    if (urlActions === "app") {
      const urlActionsType = new URLSearchParams(search).get("type");
      const urlActionsUserId = new URLSearchParams(search).get("id");
      setSelectedUser(urlActionsUserId);
      if (urlActionsType === 0) {
        fetchEmpAttendance(urlActionsUserId);
      } else {
        fetchPendingAttendance(urlActionsUserId);
      }
      fetchUsersBySuperiorByTeam();
    } else {
      if (selectedTab === 1) {
        fetchPendingAttendance(userData.id);
      } else {
        fetchEmpAttendance(userData.id);
      }
      fetchUsersBySuperior();
    }
    // fetchUsersBySuperior();
    if (userData != null) {
      setSelectedUser({
        id: userData.id,
        name: Util.titleCase(userData.firstName + " " + userData.lastName),
        fullName: Util.titleCase(userData.firstName + " " + userData.lastName),
      });
    }
  }, []);

  const fetchEmpAttendance = (param = {}) => {
    attendanceApi.getAllAttendanceByUserId(param).then((resp) => {
      try {
        setEmpAttendanceList(resp.data.data);
      } catch (error) {
        // Error handle
      }
    });
  };

  const getEmpDetails = (e) => {
    setSelectedUser(e.value);
    if (selectedTab === 1) {
      fetchPendingAttendance(e.value.id);
    } else {
      fetchEmpAttendance(e.value.id);
    }
  };

  const fetchUsersBySuperior = (param = { "pageNum": 0, "pageSize": 2000 }) => {
    // attendanceApi.getAllUsersBySuperior(param).then((resp) => {
    attendanceApi.getAllTeamAttendance(param).then((resp) => {
      try {
        resp.data.data.map(
          (user, index) =>
          (usersBySuperior[index] = {
            id: user.id,
            name: user.firstName.charAt(0).toUpperCase() + user.firstName.slice(1) + " " + user.lastName.charAt(0).toUpperCase() + user.lastName.slice(1).trimEnd(),
            fullName: user.firstName.charAt(0).toUpperCase() + user.firstName.slice(1) + " " + user.lastName.charAt(0).toUpperCase() + user.lastName.slice(1).trimEnd(),
          })
        );
        setSelectedUser(usersBySuperior[0]);
        if (userData.id) {
          const activeUsers = usersBySuperior.filter((i) => {
            return i.id === parseInt(userData.id);
          });
          setSelectedUser(activeUsers[0]);
        }
        // if (urlActions === "app") {
        //   const userId = new URLSearchParams(search).get("id");
        //   const activeUsers = usersBySuperior.filter((i) => {
        //     return i.id === parseInt(userId);
        //   });
        //   setSelectedUser(activeUsers[0]);
        // }
      } catch (error) {
        // Error handle
      }
    });
  }

  const fetchUsersBySuperiorByTeam = (param = { "pageNum": 0, "pageSize": 2000 }) => {
    attendanceApi.getAllUsersBySuperior(param).then((resp) => {
      try {
        resp.data.data.map(
          (user, index) =>
          (usersBySuperior[index] = {
            id: user.id,
            name: user.firstName.charAt(0).toUpperCase() + user.firstName.slice(1) + " " + user.lastName.charAt(0).toUpperCase() + user.lastName.slice(1).trimEnd(),
            fullName: user.firstName.charAt(0).toUpperCase() + user.firstName.slice(1) + " " + user.lastName.charAt(0).toUpperCase() + user.lastName.slice(1).trimEnd(),
          })
        );
        setSelectedUser(usersBySuperior[0]);
        // if (userData.id) {
        //   const activeUsers = usersBySuperior.filter((i) => {
        //     return i.id === parseInt(userData.id);
        //   });
        //   setSelectedUser(activeUsers[0]);
        // }
        if (urlActions === "app") {
          const userId = new URLSearchParams(search).get("id");
          const activeUsers = usersBySuperior.filter((i) => {
            return i.id === parseInt(userId);
          });
          setSelectedUser(activeUsers[0]);
        }
      } catch (error) {
        // Error handle
      }
    });
  }

  const userOptionTemplate = (data) => {
    return (
      <div className="user-item grid">
        <div className="icon">
          {data.icon == null ? (
            <span>{data.name.substr(0, 1)}</span>
          ) : (
            <img src={data.icon} />
          )}
        </div>
        <div className="label col">{data.name}</div>
      </div>
    );
  };
  const selectedUserTemplate = (data, props) => {
    if (data) {
      return (
        <div className="user-item user-item-value grid">
          <div className="icon">
            {data.icon == null ? (
              <span>{data.name.substr(0, 1)}</span>
            ) : (
              <img src={data.icon} />
            )}
          </div>
          <div className="label col p-2">{data.name}</div>
        </div>
      );
    }
    return <span>{props.placeholder}</span>;
  };

  const changeUser = (op) => {
    const curIndex = usersBySuperior.indexOf(selectedUser);
    let result = {};
    if (op == 1) {
      // Next Action
      if (curIndex < 0) {
        result = usersBySuperior[curIndex + 2];
      } else {
        if (curIndex < usersBySuperior.length - 1)
          result = usersBySuperior[curIndex + 1];
        else result = usersBySuperior[0];
      }
    } else {
      // Previous Action
      if (curIndex > 0) result = usersBySuperior[curIndex - 1];
      else result = usersBySuperior[usersBySuperior.length - 1];
    }
    setSelectedUser(result);
    if (selectedTab === 1) {
      fetchPendingAttendance(result.id);
    } else {
      fetchEmpAttendance(result.id);
    }
  };

  const cols = [
    { field: "date", header: "Date" },
    { field: "inTime", header: "In Time" },
    { field: "outTime", header: "Out Time" },
    { field: "ip", header: "IP" },
    { field: "location", header: "Location" },
  ];


  const TeamDetailsTimesheetList = () => {
    return (
      <>
        <div className="formgrid grid" style={{alignItems: 'center', justifyContent: 'space-between'}}>
          <div className="field pt-2">
            <Button type="button" label="Previous User" className="p-button-rounded p-button-secondary" icon="pi pi-angle-left" onClick={() => changeUser(-1)} />
          </div>
          <div className="field">
            <Dropdown value={selectedUser} options={usersBySuperior} onChange={(e) => getEmpDetails(e)} optionLabel="name" className="user-options" placeholder="Select a User" style={{ width: "320px" }} filter itemTemplate={userOptionTemplate} valueTemplate={selectedUserTemplate} />
          </div>
          <div className="field pt-2">
            <Button label="Next User" className="p-button-rounded" icon="pi pi-angle-right" iconPos="right" onClick={() => changeUser(1)} />
          </div>
        </div>
      </>
    );
  };


  const fetchPendingAttendance = (param = {}) => {
    attendanceApi.getPendingAttendance(param).then((resp) => {
      try {
        setEmpPendingAttendanceList(resp.data.data);
      } catch (error) {
        // Error handle
      }
    });
  };

  const onChangeTab = (e) => {
    setSelectedTab(e?.index);
    if (selectedTab === 0) {
      fetchPendingAttendance(selectedUser.id);
    } else {
      fetchEmpAttendance(selectedUser.id);
    }
  };

  const approveAttendance = (rowData, type) => {
    let param;
    if (type === 0) {
      param = {
        status: 1,
        Ids: [rowData.id],
      };
    }
    if (type === 1) {
      let attendanceIds = empPendingAttendanceList.map((a) => a.id);
      param = {
        status: 1,
        Ids: attendanceIds,
      };
    }
    try {
      // put api call
      attendanceApi.approveRejectBulkAttendance(param).then(
        (resp) => {
          if (type === 0) {
            fetchPendingAttendance(selectedUser.id);
          }
          toast.success(resp.data.message);
        },
        (err) => { }
      );
    } catch (error) { }
  };
  const fetchStatus = (status) => {
    if (status === 3) return (<div style={{ color: "rgb(222 204 90)" }}>PENDING</div>);
    if (status === 4) return (<div style={{ color: "red" }}>REJECT</div>);
  };

  const statusBodyTemplate = (data) => {
    return (
      <span style={{ borderRadius: "8px", fontSize: "12px", fontWeight: "700" }}>{fetchStatus(data.status)}</span>
    );
  }


  const fetchRecordedStatus = (status, isWeekOff, isOnLeave, isClientHoliday, isRegularize, isCompOff) => {
    if (status === 0) return (<div style={{ color: "#cb7205" }}>PARTIAL MARKIN</div>);
    if (status === 1 && !isWeekOff && !isOnLeave && !isClientHoliday && !isRegularize) return (<div style={{ color: "#a8328d" }}>COMPLETED</div>);
    if (status === 1 && isRegularize && !isWeekOff && !isCompOff) return (<div style={{ color: "#008000" }}>APPROVED</div>);
    if (status === 1 && isClientHoliday) return (<div style={{ color: "#eb34a5" }}>HOLIDAY</div>);
    if (status === 1 && isWeekOff && isRegularize) return (<div style={{ color: "#32a8a8" }}>WEEKOFF/APPROVED</div>);
    if (status === 1 && isCompOff && isRegularize) return (<div style={{ color: "#ff0080" }}>COMPOFF/APPROVED</div>);
    if (status === 2) return (<div style={{ color: "red" }}>LEAVE</div>);
  };

  const recordedStatusBodyTemplate = (data) => {
    return (
      <span style={{ borderRadius: "8px", fontSize: "12px", fontWeight: "700" }}>{fetchRecordedStatus(data.status, data.isWeekOff, data.isOnLeave, data.isClientHoliday, data.isRegularize, data.isCompOff)}</span>
    );
  };


  const rejectAttendance = (data) => {
    let param;
    param = {
      status: 4,
      rejectReason: data.reason,
      Ids: [rejectRowData.id],
    };
    try {
      // put api call
      attendanceApi.approveRejectBulkAttendance(param).then(
        (resp) => {
          fetchPendingAttendance(selectedUser.id);
          toast.error("Attendance rejected successfully");
        },
        (err) => {
          // toast.error("Unable to recall timesheet...");
        }
      );
    } catch (error) {
      // toast.error("Unable to recall timesheet...");
    }
  };

  const RejectAttendanceDialog = (data, status) => {
    return (
      <Dialog className="pop-up-dialog-recall" header="" visible={rejectDialog} onHide={() => setRejectDialog(false)}>
        <RejectAttendancePopup
          updateRejectRow={(data) => rejectAttendance(data)}
          rejectRow={rejectRowData}
          onClose={(e) => {
            setRejectDialog(false);
          }}
        />
      </Dialog>
    );
  };

  const RejectAttendance = (rowData) => {
    setRejectDialog(true);
    setRejectRowData(rowData);
  };

  const cancelReview = () => {
    attendanceRefresh();
  };

  const approveRejectAttendanceTemplate = (rowData) => {
    return (
      <div>
        <Button icon="pi pi-times" className="p-button-rounded p-button-danger" aria-label="Cancel" onClick={() => RejectAttendance(rowData)} />
        <Button icon="pi pi-check" className="p-button-rounded p-button-primary" aria-label="Submit" onClick={() => approveAttendance(rowData, 0)} />
      </div>
    );
  };

  return (
    <div>
      <TeamDetailsTimesheetList></TeamDetailsTimesheetList>
      <TabView activeIndex={selectedTab} onTabChange={(e) => { onChangeTab(e); }}>
        <TabPanel header="Recorded Attendance">
          <DataTable
            tableStyle={{ minWidth: "50rem" }}
            paginator
            responsiveLayout="scroll"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={10}
            ref={dt}
            value={empAttendanceList}
            rowsPerPageOptions={[10, 20, 50]}
            dataKey="id"
          >
            <Column field="date" header="Date"></Column>
            <Column field="inTime" body={Util.inTimeTemplate} header="In Time"></Column>
            <Column field="outTime" body={Util.outTimeTemplate} header="Out Time"></Column>
            <Column field="" body={Util.workingHoursDff} header="Total Time"></Column>
            <Column field="location" header="Location"></Column>
            <Column field="status" header="Status" body={recordedStatusBodyTemplate}></Column>
          </DataTable>

          <div className="formgrid grid mt-4">
            <div className="field col-8"></div>
            <div className="field col-4" style={{ paddingLeft: "5px" }}>
              <div className="formgrid grid">
                <div className="field col-6">
                </div>
                <div className="field col-5">
                  <Button label="Cancel" className="p-button-rounded p-button-secondary" onClick={cancelReview} />
                </div>
              </div>
            </div>
          </div>

        </TabPanel>

        <TabPanel header="Pending Attendance">
          <DataTable
            value={empPendingAttendanceList}
            tableStyle={{ minWidth: "50rem" }}
            paginator
            responsiveLayout="scroll"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={10}
            rowsPerPageOptions={[10, 20, 50]}
            dataKey="id"
          >
            <Column field="date" header="Date"></Column>
            <Column field="inTime" body={Util.inTimeTemplate} header="In Time"></Column>
            <Column field="outTime" body={Util.outTimeTemplate} header="Out Time"></Column>
            <Column field="" body={Util.workingHoursDff} header="Total Time"></Column>
            <Column field="comments" header="Reason"></Column>
            <Column field="status" header="Status" body={statusBodyTemplate}></Column>
            <Column header="Action" headerStyle={{ width: '100px', textAlign: 'center' }} bodyStyle={{ width: '100px', textAlign: 'center' }} body={approveRejectAttendanceTemplate}></Column>
          </DataTable>
          {RejectAttendanceDialog("", false)}
          <div className="formgrid grid mt-4">
            <div className="field col-12 text-right">
              <div className="formgrid grid">
                <div className="col ">
                  <Button label="Cancel" className="p-button p-button-secondary mr-1 mb-2" style={{ width: '150px' }} onClick={cancelReview} />
                  <Button label="Approve" className="p-button  p-button mr-1 mb-2" style={{ width: '150px' }} onClick={() => approveAttendance("", 1)} disabled={empPendingAttendanceList?.length === 0} />
                  <Button label="Approve & Next" className="p-button mr-1 mb-2" style={{ width: '150px' }} disabled={empPendingAttendanceList?.length === 0} onClick={() => { approveAttendance("", 1); changeUser(1) }} />
                </div>
              </div>
            </div>
          </div>
        </TabPanel>
      </TabView>
    </div>
  );
};
export default UserAttendanceDetails;
